import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import mapa from "../../assets/img/mapa-desktop.png";
import mapam from "../../assets/img/mapa-mobile.png";

const Presencia = () => {
  return (
    <section className="presencia-section">
      <Container>
        <Row className="align-items-center">
          <Col md={6}>
            <h2 className="presencia-title text-start">
              Tenemos presencia <br />
              <span>nacional</span>
            </h2>

            <div className="presencia-legend">
              <ul>
                <li className="d-flex justify-content-start align-items-start">
                  <div>
                    <span className="dot green"></span>
                  </div>
                  Oficinas regionales.
                </li>
                <li className="d-flex justify-content-start align-items-start">
                  <div>
                    <span className="dot pink"></span>
                  </div>
                  Asesores en puntos estratégicos.
                </li>
                <li className="d-flex justify-content-start align-items-start">
                  <div>
                    <span className="dot blue"></span>
                  </div>
                  Módulos de atención y servicio dentro de las oficinas de nuestros clientes.
                </li>
              </ul>
            </div>
          </Col>

          <Col md={6} className="text-center">
            <img src={mapa} alt="Mapa de presencia" className="img-fluid presencia-map" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Presencia;
